import {
  eventBus,
  INTERNAL_EVENTS,
  useTracksStore,
} from '@cometchat/calls-sdk-core';
import JitsiMeetJS from '../../../calls-sdk-core/lib-jitsi-meet';

async function queryPermissions() {
  try {
    const [cameraPermission, microphonePermission] = await Promise.all([
      navigator.permissions.query({ name: 'camera' as PermissionName }),
      navigator.permissions.query({ name: 'microphone' as PermissionName }),
    ]);

    useTracksStore.setState(state => ({
      permissions: {
        ...state.permissions,
        video: cameraPermission.state === 'granted',
        audio: microphonePermission.state === 'granted',
        initialized: true,
      },
    }));
  } catch (error) {
    console.warn('Failed to query initial permissions:', error);
  }
}

function setupDevicePermissionTracking() {
  const { mediaDevices } = JitsiMeetJS;
  mediaDevices.addEventListener(
    JitsiMeetJS.events.mediaDevices.PERMISSIONS_CHANGED,
    (permissions: { audio?: boolean; video?: boolean }) => {
      useTracksStore.setState(state => ({
        permissions: {
          ...state.permissions,
          ...permissions,
        },
      }));
    },
  );
}

eventBus.subscribe(INTERNAL_EVENTS.lifecycle.SDKInitialized, () => {
  queryPermissions();
  setupDevicePermissionTracking();
});
